

















import Vue from 'vue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default Vue.extend({
    name: 'RangeDatetimeFilter',
    components: {
        DatePicker,
    },
    props: {
        /** код для опознания значения в общем массиве фильтров */
        code: {
            type: String,
            required: true,
        },
        /** подпись */
        label: {
            type: String,
            required: false,
            default: 'Период:',
        },
        defaultTimeValue: {
            type: Array,
            required: false,
            default() {
                // текущая дата от начала дня до настоящего момента
                const defaultStartDate = new Date();
                defaultStartDate.setHours(0, 0, 0, 0);
                const defaultEndDate = new Date();
                defaultEndDate.setHours(23, 59, 59, 99);
                return [defaultStartDate, defaultEndDate] as Array<Date>;
            }
        },
    },
    computed: {},
    methods: {
        inputHandler() {
            // Если пользователь совершил очистку интервала - вернём null
            let resultObject = { code: this.code, value: null as Array<Date> | null };
            if (
                this.datetime !== null &&
                this.datetime !== undefined &&
                this.datetime.length &&
                this.datetime.length === 2 &&
                this.datetime[0] !== null &&
                this.datetime[1] !== null
            ) {
                resultObject = { code: this.code, value: this.datetime };
            }
            this.$emit('input', resultObject);
        },
    },
    mounted() {
        this.inputHandler();
    },
    data() {
        return {
            datetime: this.defaultTimeValue as Array<Date>,
        };
    }
});
